<template>
    <div>
        <!-- 입금전 상세 정보 -->
        <div v-if="showLayout">
            <!-- 주문정보 -->
            <order-information-layout
                :order-data="orderData"
            ></order-information-layout>
            <!-- 배송정보 -->
            <shipping-information-layout
                ref="ShippingInformationLayout"
                :setValidatorArr="setValidatorArr"
                :setImportLayoutNames="setImportLayoutNames"
                :setComponentData="setComponentData"
                :orderClass="orderClass"
                :order-data="orderData"
            ></shipping-information-layout>
            <!-- 입금정보 TODO : 무통장 입금 들어올 경우 진행. -->
<!--            <deposit-information-layout
                :orderData="orderData"
            ></deposit-information-layout>-->
            <!-- 상태 -->
            <order-status-layout
                :order-data="orderData"></order-status-layout>
            <!-- 메모 -->
            <order-memo-layout
                ref="OrderMemoLayout"
                :setImportLayoutNames="setImportLayoutNames"
                :setValidatorArr="setValidatorArr"
                :setComponentData="setComponentData"
                :orderData="orderData"
                :orderClass="orderClass"

            ></order-memo-layout>
            <!-- 저장 버튼 layout -->
            <before-deposit-save-layout
                :runWrite="runWrite"
                :orderKey="orderKey"
                :orderClass="orderClass"></before-deposit-save-layout>
        </div>
    </div>
</template>

<script>
import OrderInformationLayout from "@/components/order/layout/orderWrite/OrderInformationLayout.vue";
import ShippingInformationLayout from "@/components/order/layout/orderWrite/ShippingInformationLayout.vue";
import DepositInformationLayout from "@/components/order/layout/orderWrite/DepositInformationLayout.vue";
import OrderStatusLayout from "@/components/order/layout/orderWrite/OrderStatusLayout.vue";
import OrderMemoLayout from "@/components/order/layout/orderWrite/OrderMemoLayout.vue";
import util from "@/mixins/util";
import EventBus from "@/mixins/event-bus";
import alertMixins from "@/mixins/alertMixins";
import Order from "@/components/order/order"
import {mapState} from "vuex";

import orderValidator from "@/components/order/orderValidator";
import BeforeDepositSaveLayout from "@/components/order/layout/orderWrite/BeforeDepositSaveLayout.vue";

export default {
    name: "BeforeDepositComponent",
    mixins: [alertMixins,orderValidator],
    components: {
        BeforeDepositSaveLayout,
        OrderMemoLayout,
        OrderStatusLayout, DepositInformationLayout, ShippingInformationLayout, OrderInformationLayout},
    inject: [],
    provide() {
        return {}
    },
    props: {
        orderKey:{default:0},
    },
    data() {
        return {
            orderClass:null,
            showLayout:false,
            orderData:{},
            orderType : 'updateOrder',

            isRunning: false,
            validatorArr: [],
            importLayoutNames: [],
        }
    },
    beforeRouterEnter() {
    },
    created() {
        this.orderClass = new Order.OrderClass(this.UserInfo)
        if(this.orderKey == 0){
            this.$router.back()
            return false
        }
        this.getOrder();
    },
    mounted() {
    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {
        ...mapState({
            UserInfo: state => state.userInfo.UserInfo,
        })
    },
    methods: {
        setValidatorArr(arr) {
            this.validatorArr = this.$_.concat(this.validatorArr, arr)
            this.validatorArr = this.$_.uniq(this.validatorArr)
        },
        setImportLayoutNames(name) {
            this.importLayoutNames.push(name);
            this.importLayoutNames = this.$_.uniq(this.importLayoutNames)
        },
        setComponentData(type, value) {
            this[type] = value;
        },
        loadLayout() {
            this.showLayout = true;
        },
        getOrder(){
            EventBus.$emit('changeLoading', true);
            let params = {
                type : 'basic',
                f :1,
                // st :[10],
                ip : 0,
                or : 1, // 주문정보
                oa : 1, // 배송정보
                ba : 1, // 입금정보
                ccl :1, // 취소정보
                id :this.orderKey,
            }
            try {
                this.$api.$order.getOrder(params).then(res => res.Data.Result).then(res => {
                    EventBus.$emit('changeLoading', false );
                    if(!util.isEmpty(res.List) && res.Info.Type == 1) {
                        this.orderData = this.orderClass.getOrderBeforeData(res.List[0])
                       this.loadLayout();
                    }else {
                        this.errorAlert('데이터를 불러오지 못했습니다.')
                    }
                })
            }catch (e) {
                console.log(e)
            }
        },
        _makeSendParams() {
            let params = {
                o_idx: this.orderData.orderIdx,  //주문번호
                o_memo: this.detailMemo,// 관리자 메모
                oa_addr1: this.address,//경기도 용인시 12
                oa_addr2 : this.addressDetail,// 연원로512
                oa_zip : this.zipCode,// 우편번호

            }
            return params;
        },
        _checkValidator() {
            return this.$validate(this.validatorArr).then(success => {
                if(!success) {
                    this.errorAlert('필수데이터를 확인해주세요.')
                    util.Array.each(this.importLayoutNames, (layout, index, arr) => {
                        if(this.$refs.hasOwnProperty(layout) && this.$refs[layout].hasOwnProperty('checkValidator')) {
                            this.$refs[layout].checkValidator();
                        }
                    });
                }
                return success
            })
        },
        async runWrite(){
            let validator = await this._checkValidator();
            if(!validator) {
                return false;
            }
            if(this.isRunning) {
                return false;
            }
            this.isRunning = true;
            EventBus.$emit('changeLoading', true)
            let params = this._makeSendParams();
            let result = await this.orderClass.runWrite(this.orderType, params);

            if(result.resultData.status === true) {
                this.afterFunc()
            }
        },
        afterFunc() {
            EventBus.$emit('changeLoading', false);
            this.createAlert({
                title: "",
                content: '수정되었습니다.',
                btnText: "확인",
                hide: () => {
                    this.$router.back()
                }
            });
        },

    },
    watch: {},
}
</script>

<style scoped>

</style>
